// Helper function to convert rgba/rgb to hex for color inputs
export const colorToHex = (color: string): string => {
    if (!color) return "#000000";
    
    // If already hex, return as is
    if (color.startsWith("#")) {
      return color.length === 4 ? `#${color[1]}${color[1]}${color[2]}${color[2]}${color[3]}${color[3]}` : color;
    }
    
    // Convert rgba/rgb to hex
    if (color.startsWith("rgba") || color.startsWith("rgb")) {
      const matches = color.match(/\d+/g);
      if (matches && matches.length >= 3) {
        const r = parseInt(matches[0]);
        const g = parseInt(matches[1]);
        const b = parseInt(matches[2]);
        return `#${[r, g, b].map(x => {
          const hex = x.toString(16);
          return hex.length === 1 ? "0" + hex : hex;
        }).join("")}`;
      }
    }
    
    return "#000000";
  };